import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import {
  ResidentPreQualificationCreateModel,
  ResidentPreQualificationModel,
} from 'src/features/resident-pre-qualification/types';

export function fetchResidentPreQualificationService(
  homeId: string,
  client: ApiClient = apiClient,
) {
  return client.get<ResidentPreQualificationModel>(
    `/resident-pre-qualifications/${homeId}`,
  );
}

export function createResidentPreQualificationService(
  data: ResidentPreQualificationCreateModel,
  client: ApiClient = apiClient,
) {
  return client.post<ResidentPreQualificationModel>(
    '/resident-pre-qualifications',
    data,
  );
}
